import { HttpError } from "@refinedev/core";
import { Create, useAutocomplete } from "@refinedev/mui";
import { Box, TextField, Autocomplete, Grid } from "@mui/material";
import { useForm } from "@refinedev/react-hook-form";

import { Controller } from "react-hook-form";

import { IFisUser, Nullable } from "./interfaces";
import React from "react";

export const FisUserCreate: React.FC = () => {
    const {
        saveButtonProps,
        register,
        control,
        formState: { errors },
    } = useForm<IFisUser, HttpError, Nullable<IFisUser>>();

    return (
        <Create saveButtonProps={saveButtonProps}>
            <Box
                component="form"
                sx={{ display: "flex", flexDirection: "column" }}
                autoComplete="off"
            >
                <Grid container direction="row" justifyContent="space-between">
                <TextField sx={{ width: '45%' }}
                    id="loginId"
                    {...register("loginId", {
                        required: "This field is required",
                    })}
                    error={!!errors.loginId}
                    helperText={errors.loginId?.message}
                    margin="normal"
                    fullWidth
                    label="로그인ID"
                    name="loginId"
                    autoFocus
                    required
                    InputLabelProps={{ shrink: true }}
                />
                <TextField sx={{ width: '45%' }}
                    id="name"
                    {...register("name", {
                        required: "This field is required",
                    })}
                    error={!!errors.name}
                    helperText={errors.name?.message}
                    margin="normal"
                    fullWidth
                    label="이름"
                    name="name"
                    autoFocus
                    required
                    InputLabelProps={{ shrink: true }}
                />
                </Grid>

                <Grid container direction="row" justifyContent="space-between">
                <TextField sx={{ width: '45%' }}
                    id="password"
                    {...register("password", {
                        required: "This field is required",
                    })}
                    error={!!errors.password}
                    helperText={errors.password?.message}
                    margin="normal"
                    fullWidth
                    label="비밀번호"
                    name="password"
                    type="password"
                    required
                    InputLabelProps={{ shrink: true }}
                />
                <TextField sx={{ width: '45%' }}
                    id="passwordCheck"
                    {...register("passwordCheck", {
                        required: "This field is required",
                    })}
                    error={!!errors.passwordCheck}
                    helperText={errors.passwordCheck?.message}
                    margin="normal"
                    fullWidth
                    label="비밀번호 확인"
                    name="passwordCheck"
                    type="password"
                    required
                    InputLabelProps={{ shrink: true }}
                />
                </Grid>

                <Grid container direction="row" justifyContent="space-between">
                <TextField sx={{ width: '45%' }}
                    id="phoneNumber"
                    {...register("phoneNumber", {
                        required: "This field is required",
                        onChange: (e) => {
                            const value = e.target.value.replace(/-/g, '');
                            let formattedPhone = ''

                            if (value.length < 4) {
                                formattedPhone = value
                            } else if (value.startsWith('02')) {
                                if (value.length < 7) {
                                    formattedPhone = `${value.slice(0, 2)}-${value.slice(2)}`
                                } else if (value.length < 10) {
                                    formattedPhone = `${value.slice(0, 2)}-${value.slice(2, 5)}-${value.slice(5)}`
                                } else {
                                    formattedPhone = `${value.slice(0, 2)}-${value.slice(2, 6)}-${value.slice(6, 10)}`
                                }
                            } else {
                                if (value.length < 8) {
                                    formattedPhone = `${value.slice(0, 3)}-${value.slice(3)}`
                                } else if (value.length < 11) {
                                    formattedPhone = `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6)}`
                                } else {
                                    formattedPhone = `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(7, 11)}`
                                }
                            }

                            const displayPhone = formattedPhone.length > 0 ? formattedPhone : ''
                            e.target.value = displayPhone;
                        }
                    })}
                    error={!!errors.phoneNumber}
                    helperText={errors.phoneNumber?.message}
                    margin="normal"
                    fullWidth
                    label="전화번호"
                    name="phoneNumber"
                    required
                    InputLabelProps={{ shrink: true }}
                />
                <Controller
                    control={control}
                    name="auth"
                    rules={{ required: "This field is required" }}
                    // eslint-disable-next-line
                    defaultValue={null as any}
                    render={({ field }) => (
                        <Autocomplete  sx={{ width: '45%' }}
                            id="auth"
                            options={["ADMIN", "MANAGER", "USER", "AGENT"]}
                            {...field}
                            onChange={(_, value) => {
                                field.onChange(value);
                            }}
                            renderInput={(params) => (
                                <TextField 
                                    {...params}
                                    label="권한"
                                    margin="normal"
                                    variant="outlined"
                                    error={!!errors.auth}
                                    helperText={errors.auth?.message}
                                    required
                                    InputLabelProps={{ shrink: true }}
                                    />
                            )}
                        />
                    )}
                />
                </Grid>
                <TextField
                    id="sDate"
                    {...register("sDate", {
                        required: false,
                        onChange: (e) => {
                            const value = e.target.value.replace(/-/g, '');
                            let formattedPhone = ''

                            if (value.length < 5) {
                                formattedPhone = value
                            } else {
                                if (value.length < 8) {
                                    formattedPhone = `${value.slice(0, 4)}-${value.slice(4)}`
                                } else {
                                    formattedPhone = `${value.slice(0, 4)}-${value.slice(4, 6)}-${value.slice(6, 8)}`
                                }
                            }

                            const displayPhone = formattedPhone.length > 0 ? formattedPhone : ''
                            e.target.value = displayPhone;
                        }
                    })}
                    error={!!errors.sDate}
                    helperText={errors.sDate?.message}
                    margin="normal"
                    fullWidth
                    label="입사일"
                    name="sDate"
                    placeholder="YYYY-MM-DD"
                    InputLabelProps={{ shrink: true }}
                />
                <TextField
                    id="address"
                    {...register("address", {
                        required: false,
                    })}
                    error={!!errors.address}
                    helperText={errors.address?.message}
                    margin="normal"
                    fullWidth
                    label="주소"
                    name="address"
                    InputLabelProps={{ shrink: true }}
                />
            </Box>
        </Create>
    );
};